<template>
  <transition name="v-fade">
    <app-modal
      v-if="isModalOpen"
      v-qa="`ds_warning_modal`"
      @close-modal="toggle(false)">
      <template #modal-header>
        {{ modalTitle }}
      </template>
      <template #modal-body>
        <div v-html="translationTag"/>
      </template>
    </app-modal>
  </transition>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import AppModal from '~/app/shared/ui/modal/modal.vue';

export default {
  name: 'WarningModal',
  components: { AppModal },
  computed: {
    ...mapState('debt-sold', ['isModalOpen']),
    ...mapGetters('debt-sold', ['tag', 'translationTag', 'modalTitle']),
  },
  mounted() {
    if (this.tag) this.toggle(true);
  },
  methods: {
    ...mapMutations('debt-sold', ['toggle']),
  },
};
</script>
